import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-refresh-icon',
  templateUrl: 'refresh-icon.component.html'
})
export class RefreshIconComponent {
  constructor() {}
}
